import React from "react";

const Glass = ({ content, direction, additionalStyles = {} }) => {
  const glassStyle = {
    fontSize: 18,
    fontWeight: "bold",
    position: "relative",
    zIndex: 10,
    padding: 16,
    minHeight: 100,
    borderRadius: 8,
    color: "#fdfdfd",
    borderRadius: "8px",
    // margin: "10px",
    textAlign: "center",
    background: "linear-gradient(180deg, rgba(40, 40, 40, 0.6), rgba(50, 50, 50, 0.2))",
    // boxShadow: "0px 0px 10px #999",
  };
  const finalGlassStyle = { ...glassStyle, ...additionalStyles };
  return <div style={finalGlassStyle}>{content}</div>;
};

export default Glass;
